import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=7e61040c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./NotificationDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports